module.exports = __webpack_public_path__ + "img/welcome-parent-mode-2.197ab3a5.png";